var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoneMarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#3030AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6358 4.32139L6.91352 9.23645L4.39122 6.61119C4.28975 6.50184 4.16837 6.41462 4.03416 6.35462C3.89996 6.29461 3.75562 6.26303 3.60956 6.26171C3.4635 6.26039 3.31865 6.28936 3.18347 6.34692C3.04828 6.40449 2.92546 6.4895 2.82218 6.597C2.7189 6.7045 2.63722 6.83233 2.58191 6.97303C2.5266 7.11374 2.49877 7.2645 2.50004 7.41652C2.50131 7.56854 2.53166 7.71877 2.58931 7.85845C2.64696 7.99814 2.73076 8.12447 2.83582 8.23008L6.13582 11.6648C6.3421 11.8794 6.62184 12 6.91352 12C7.2052 12 7.48494 11.8794 7.69122 11.6648L13.1912 5.94028C13.3916 5.72435 13.5025 5.43514 13.5 5.13495C13.4975 4.83476 13.3818 4.54761 13.1778 4.33533C12.9739 4.12306 12.698 4.00265 12.4096 4.00004C12.1211 3.99743 11.8433 4.11283 11.6358 4.32139Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoneMarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doneMarkIcon.06d8781aeddba1816c8eeadfddd93f1d.svg";